/* eslint-disable @typescript-eslint/naming-convention */
import { fetchSiteInfoQuery } from "app/services/sitesService/queries/sitesQueries";
import type { SiteInfoResponse } from "app/services/sitesService/types";

import type { IOpportunityListItemTrackStatus } from "../../pages/workspace/common/types";
import { DefaultFetchService } from "../fetchService";

export interface Data {
    [key: string]: DataCom;
}
export interface KeysDataVerification {
    [key: string]: boolean;
}
export interface DataCom {
    TotalVisits: number;
    Change: number;
    ShareOfVisits: number;
    Trend: number[];
}

export interface SingleMetric {
    FromAlternativeSources?: boolean;
    Data?: Data;
    KeysDataVerification?: KeysDataVerification;
}

export default class BaseWorkspaceApiService {
    protected fetchService: DefaultFetchService = DefaultFetchService.getInstance();

    /**
     * Helps to know whether domain + country tracked
     *
     * @param {string} domain
     * @param {number} country
     *
     * @returns {Promise<{isTracked: boolean}>}
     */
    public getTrackingStatus(domain: string): Promise<IOpportunityListItemTrackStatus[]> {
        const ApiEndPoint = `/api/userdata/workspaces/workspace/opportunities-track-status/${domain}`;
        return this.fetchService.get<IOpportunityListItemTrackStatus[]>(ApiEndPoint).then((items) => {
            return items.sort((a, b) => {
                if (a.opportunityListName < b.opportunityListName) {
                    return -1;
                }
                if (a.opportunityListName > b.opportunityListName) {
                    return 1;
                }
                return 0;
            });
        });
    }

    public getWebsiteHeader(
        domain: string,
        country: string | number,
        startDate: string,
        endDate: string,
    ): Promise<SiteInfoResponse | null> {
        return fetchSiteInfoQuery({
            keys: domain,
            country: String(country),
            from: startDate,
            to: endDate,
            includeCrossData: true,
            includeSubDomains: true,
            isWindow: false,
            mainDomainOnly: false,
            timeGranularity: "Monthly",
            webSource: "Total",
        });
    }

    public async getWebsiteRanks(
        domain: string,
        country: string,
        startDate: string,
        endDate: string,
    ): Promise<SingleMetric> {
        const query = new URLSearchParams();
        query.set("country", country);
        query.set("from", startDate);
        query.set("includeCrossData", "true");
        query.set("includeSubDomains", "true");
        query.set("isWindow", "false");
        query.set("keys", domain);
        query.set("mainDomainOnly", "false");
        query.set("timeGranularity", "Monthly");
        query.set("to", endDate);
        query.set("webSource", "Total");

        const ApiEndPoint = `/widgetApi/WebsiteOverview/WebRanks/SingleMetric?${query.toString()}`;

        try {
            const response = await this.fetchService.get<SingleMetric>(ApiEndPoint);
            return response;
        } catch (_error: unknown) {
            return {};
        }
    }
}
